// Where the open document lives and which client it is open in, for Save to Jylo's
// defaults. Common API, so the same in Word, Excel and PowerPoint. Read at the moment of
// use: neither exists at module scope, and under Jest there is no Office at all.

/** The document's path or URL, or "" for one never saved (or a host that will not say). */
export function readDocumentUrl(): string {
  try {
    return Office.context.document?.url ?? "";
  } catch {
    return "";
  }
}

/** `Office.context.platform` as its string value ("PC", "Mac", "OfficeOnline", ...). */
export function readOfficePlatform(): string | undefined {
  try {
    return Office.context.platform as unknown as string;
  } catch {
    return undefined;
  }
}
